
// Libraries
var React = require('react');

// Styles
require('./Sponsors.scss');

class SecondarySponsors extends React.Component {
	render() {
		return (		
			<div className={"Sponsors__secondary"}>
				{this.props.data.map((item, index) => {

					var element = null;
					if(item.link != null) {
						element = <a href={item.link.url} target={item.link.newWindow ? "_blank" : "_self"} rel={item.link.newWindow ? "noopener sponsored" : "sponsored"}  ><img src={item.image.url} alt={item.image.altText} /></a> 
					} else {
						element = <img src={item.image.url} alt={item.image.altText} />
					}
					return(         
						<div className={"Sponsors__secondary__sponsor"} key={index}>
							{element}
							{item.link && item.link.caption.length > 0 &&
								<p className="Sponsors__caption">{item.link.caption}</p>
							}	
						</div>
					);
					
				})}
			</div>
		)
	}
}

module.exports = SecondarySponsors;


// WEBPACK FOOTER //
// ./src/components/Sponsors/SecondarySponsors.js